import { axiosPrivate } from "../../api/axios";

const getEarningsDashboard = async (page = 1, limit = 20) => {
  const response = await axiosPrivate.get(
    `/affiliate-earnings/dashboard?page=${page}&limit=${limit}`,
  );
  return response.data;
};

const getEarningsHistory = async () => {
  const response = await axiosPrivate.get(
    `/affiliate-earnings/my-earnings-history`,
  );
  return response.data;
};

const getAllEarnings = async (page = 1, limit = 10) => {
  const response = await axiosPrivate.get(
    `/affiliate-earnings/all?page=${page}&limit=${limit}`,
  );
  return response.data;
};

const getUserEarnings = async (userId) => {
  const response = await axiosPrivate.get(`/affiliate-earnings/user/${userId}`);
  return response.data;
};

const processPayment = async (userId, paymentData) => {
  const response = await axiosPrivate.post(
    `/affiliate-earnings/process-payment/${userId}`,
    paymentData,
  );
  return response.data;
};

const earningsService = {
  getEarningsDashboard,
  getEarningsHistory,
  getAllEarnings,
  getUserEarnings,
  processPayment,
};

export default earningsService;
